import { DropResult } from "react-beautiful-dnd";

export const validateManufacturingWorkingUnitDrop = (result: DropResult): boolean => {
  const destinationArray = result.destination?.droppableId.split("$");
  const sourceArray = result.source.droppableId.split("$");

  if (
    destinationArray &&
    destinationArray[0] === "plan" &&
    sourceArray[0] === "shelf" &&
    result.destination?.droppableId !== result.draggableId
  )
    return true;
  return false;
};
